import $ from 'jquery';

$(function () {
    const $block = $('.bloc-plan-formation');

    if ($block.length) {
        // Handle click on item header
        $block.find('.timeline-item.item').on('click', function (e) {
            const $item = $(this);
            const $expandedContent = $item.find('.item-expanded-content');

            if ($expandedContent.length > 0) {
                $item.toggleClass('expanded');
            }
        });
    }
});
